'use client'

import cx from 'classnames'

import SubmitButton from '@/components/Form/Atoms/SubmitButton'
import { SurveyFormComponentType } from '@/components/Form/Organisms/SurveyForm/Form/index'
import SurveyFormCheckbox from '@/components/Form/Organisms/SurveyForm/SurveyFormOption/SurveyFormCheckbox'
import SurveyFormRadio from '@/components/Form/Organisms/SurveyForm/SurveyFormOption/SurveyFormRadio'
import SurveyFormSimpleCheckbox from '@/components/Form/Organisms/SurveyForm/SurveyFormOption/SurveyFormSimpleCheckbox'
import SurveyFormText from '@/components/Form/Organisms/SurveyForm/SurveyFormOption/SurveyFormText'

export default function FormLogic({ survey, form, handleSubmit, simple = false }: SurveyFormComponentType) {
  const surveyAnswersKeyName = 'surveyAnswers'

  return (
    <>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <div className={cx('u-font-yu-min', 'c-surveyForm-surveyForm')}>
          <h2 className={cx('u-mb30', 'c-surveyForm-surveyForm__title')}>{survey.name}</h2>
          <div>
            {survey.surveyQuestions.map((surveyQuestion, index) => {
              const indexLabel = survey.surveyQuestions.length > 1 ? index : null

              return (
                <div className={cx('u-mb20')} key={surveyQuestion.surveyQuestionId}>
                  {surveyQuestion.type == 'checkbox' ? (
                    simple ? (
                      <SurveyFormSimpleCheckbox
                        surveyQuestion={surveyQuestion}
                        surveyAnswersKeyName={surveyAnswersKeyName}
                        index={indexLabel}
                      />
                    ) : (
                      <SurveyFormCheckbox
                        surveyQuestion={surveyQuestion}
                        surveyAnswersKeyName={surveyAnswersKeyName}
                        index={indexLabel}
                      />
                    )
                  ) : surveyQuestion.type == 'radio' ? (
                    <SurveyFormRadio
                      surveyQuestion={surveyQuestion}
                      surveyAnswersKeyName={surveyAnswersKeyName}
                      index={indexLabel}
                    />
                  ) : surveyQuestion.type == 'text' ? (
                    <SurveyFormText
                      surveyQuestion={surveyQuestion}
                      surveyAnswersKeyName={surveyAnswersKeyName}
                      index={indexLabel}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              )
            })}
          </div>

          <div className={cx('c-surveyForm-surveyForm__buttons')}>
            <div className={cx('c-surveyForm-surveyForm__button')}>
              <SubmitButton
                width={'100%'}
                allowDirty={survey.surveyQuestions.every((surveyQuestion) => !surveyQuestion.answerRequired)}
              >
                アンケートに答える
              </SubmitButton>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}
